import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { getPortalSdkUrl } from "@jari-tools/shared";
import { loadPortalSdk } from "./portal-sdk";
import { App } from "./App";
import "./tool.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

function renderApp() {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

loadPortalSdk(getPortalSdkUrl())
  .catch(() => {
    // Portal unreachable, App shows auth error; DevAccessPill works in dev.
  })
  .finally(renderApp);
